import {Icon} from '@wandb/weave/components/Icon';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';

import {createDismissibleBanner} from '../../../../pages/Billing/AccountSettings/WarningBanner/DismissibleBanner';
import {cyrb53} from '../../../../util/hash';
import {
  Banner,
  BannerBoldText,
  BannerFlexWrapper,
  BannerTextWrapper,
} from '../../../Banner';
import {globalRegistryType} from '../../common/utils';
import {useGetMigratedRegistryEntityInfo} from '../hooks';

export type MigrationInfoBannerProps = {
  registry: globalRegistryType;
  userID: string;
};

export const MigrationInfoBanner =
  createDismissibleBanner<MigrationInfoBannerProps>({
    id: ({registry, userID}) =>
      cyrb53(registry.registryProjectInternalId + ':' + userID).toString() +
      ':migration-info',
    Component: ({registry, onDismiss}) => {
      // Fetch the team name, whose legacy model registry was migrated
      const {
        legacyMREntityName,
        migrationCompletedAt,
        isMigratedRegistryProject,
      } = useGetMigratedRegistryEntityInfo(
        registry.entityName,
        registry.registryProjectName
      );
      const redactedEntityName =
        legacyMREntityName ?? '(name hidden due to permissions)';
      if (!isMigratedRegistryProject) {
        return null;
      }
      return (
        <Tailwind>
          <Banner
            data-test="migration-info-banner"
            variant={'info'}
            className="my-16">
            <BannerFlexWrapper>
              <div>
                <Icon name="lightbulb-info" />
              </div>
              <BannerTextWrapper className="px-12">
                <span>
                  <BannerBoldText>
                    This registry was created from a migration.{' '}
                  </BannerBoldText>
                  The legacy model registry of team, "{redactedEntityName}" was
                  migrated to this new W&B Registry on {migrationCompletedAt}.
                </span>
              </BannerTextWrapper>
            </BannerFlexWrapper>
            <button
              className="flex items-center border-none bg-transparent font-semibold text-moon-800 hover:cursor-pointer hover:text-moon-950"
              onClick={() => {
                onDismiss();
              }}>
              <Icon name="close" />
            </button>
          </Banner>
        </Tailwind>
      );
    },
  });
